import type { MapCoreApi } from "../core/api";
import { geometryPoints, parseWkt } from "../geo/wkt";

export const featureZoom = 17;

export function zoomToOpenFeature(core: MapCoreApi, minZoom = featureZoom): void {
  const info = core.store.getState().info;
  const points = info.kind === "tile" ? geometryPoints(parseWkt(info.feature.feature.wkt)) : [];

  if (points.length === 1) core.view.setView(points[0], Math.max(core.store.getState().view.zoom, minZoom));
  else if (points.length > 1) {
    const lats = points.map(a => a[0]);
    const lons = points.map(a => a[1]);

    core.view.fitBounds([
      [Math.min(...lats), Math.min(...lons)],
      [Math.max(...lats), Math.max(...lons)]
    ]);
  }
}
